import React from "react";
import { Box, Button, Typography, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LandingFooter = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ position: "relative", zIndex: 2 }}>
      {/* Footer content */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingX: 4,
          paddingY: 2,
          backgroundColor: "#ffffff",
        }}
      >
        {/* Left: Copyright */}
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontWeight: 400,
            fontSize: "0.875rem",
          }}
        >
          © {new Date().getFullYear()} Cory Hixson Tutoring
        </Typography>

        {/* Right: Links */}
        <Stack direction="row" spacing={2}>
          {[
            { label: "Privacy", href: "/privacy" },
            { label: "Terms", href: "/terms" },
            { label: "Contact", href: "/contact" },
          ].map(({ label, href }) => (
            <Button
              key={label}
              variant="text"
              onClick={() => navigate(href)}
              sx={{
                color: "text.primary",
                textTransform: "none",
                fontSize: "0.875rem",
                fontWeight: 400,
                minWidth: 0,
                paddingX: 1,
              }}
            >
              {label}
            </Button>
          ))}
        </Stack>
      </Box>

      {/* Gradient fade at top */}
      <Box
        sx={{
          position: "absolute",
          bottom: "100%",
          left: 0,
          width: "100%",
          height: "60px",
          background: "linear-gradient(to top, #ffffff, rgba(255,255,255,0))",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};

export default LandingFooter;
